import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  Grid,
  Paper,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-jalaali'
import { useParams, useNavigate } from 'react-router-dom'
import {
  getScholarship, getScholarshipVotes, vote, approve,
} from '../../app/slices/scholarshipSlice'
import ScholarshipForm from './scholarshipForm/FormStep'
import ProfileView from '../account/ProfileView'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '10px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    flexGrow: 1,
    textAlign: 'right',
  },
}))

export const ScholarshipReview = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()

  const [expanded, setExpanded] = React.useState(false)

  const loggedInUser = useSelector((state) => state.user)
  const isReferee = loggedInUser?.role?.roleId === 6
  const isScholarManager = loggedInUser?.role?.roleId === 5

  const scholarship = useSelector((state) => state.scholarship.current)
  const scholarshipVotes = useSelector(
    (state) => (isReferee ? null : state.scholarship.currentVotes),
  )

  const [userResponse, setUserResponse] = useState(null)
  const [voteComment, setVoteComment] = useState(null)

  const couldVote = (scholarship.scholarshipRequestStatus === 100
  || scholarship.scholarshipRequestStatus === 110)
  && !isScholarManager && (isReferee
    || (scholarshipVotes && scholarshipVotes.findIndex(
      (item) => item?.user?.userId === loggedInUser?.user?.userId,
    ) === -1))

  useEffect(() => {
    dispatch(getScholarship(id))
    if (!isReferee) {
      dispatch(getScholarshipVotes(id))
    }
  }, [])

  const handleClose = (isOk) => {
    if (isOk) {
      if (userResponse.isVote) {
        dispatch(vote({
          scholarshipRequestId: id,
          comment: voteComment,
          IsConfirmed: userResponse.isOk,
          userId: scholarship.user.userId,
        }, () => {
          if (isReferee) navigate('../..')
        }))
      } else {
        dispatch(approve({
          scholarshipRequestId: id,
          ScholarshipRequestStatus: userResponse.isOk ? 110 : 105,
        }, () => navigate('../..')))
      }
    }
    setUserResponse(null)
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <Paper className={classes.root}>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography className={classes.heading}>اطلاعات کاربر</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {scholarship?.user && (
          <ProfileView />
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion expanded>
        <AccordionSummary>
          <Typography className={classes.heading}>فرم درخواست بورسیه</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ScholarshipForm />
        </AccordionDetails>
      </Accordion>
      {!isReferee
        ? (
          <Accordion expanded>
            <AccordionSummary>
              <Typography className={classes.heading}>نتایج داوری</Typography>
              <Typography className={classes.secondaryHeading}>
                گروه داوری :
                {' '}
                {scholarship?.refereeGroup?.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {scholarshipVotes && scholarshipVotes.length
                ? (
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>داور</TableCell>
                          <TableCell>رای</TableCell>
                          <TableCell>تاریخ ثبت</TableCell>
                          <TableCell>نظر</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {scholarshipVotes.map((voteItem) => (
                          <TableRow key={voteItem.refereeingId}>
                            <TableCell component="th" scope="row">
                              {voteItem.referee.userName}
                            </TableCell>
                            <TableCell>
                              {voteItem.isConfirmed ? 'موافق بورسیه' : 'مخالف'}
                            </TableCell>
                            <TableCell>{moment(voteItem.createDate)?.format('jYYYY/jMM/jDD')}</TableCell>
                            <TableCell style={{ width: '40%' }}>{voteItem.comment}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )
                : <Typography>رای ای ثبت نشده!</Typography>}
            </AccordionDetails>
          </Accordion>
        )
        : null}
      {couldVote
        ? (
          <Accordion expanded>
            <AccordionSummary>
              <Typography className={classes.heading}>رای شما</Typography>
              <Typography className={classes.secondaryHeading}>شرکت در فرآیند داوری</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="نظر در خصوص داوری"
                    outlined
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    placeholder=" در صورت تمایل لطفا نظر خود را وارد کنید"
                    value={voteComment}
                    onChange={(e) => { setVoteComment(e.target.value) }}
                  />
                </Grid>
                <Grid item xs={12} md={5}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setUserResponse({
                        isVote: true,
                        isOk: true,
                      })
                    }}
                  >
                    موافق ارایه بورسیه هستم
                  </Button>
                </Grid>
                <Grid item xs={12} md={2} />
                <Grid item xs={12} md={5}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setUserResponse({
                        isVote: true,
                        isOk: false,
                      })
                    }}
                  >
                    با ارایه بورسیه مخالفم
                  </Button>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )
        : null}
      {!isReferee
        ? (
          <Accordion expanded>
            <AccordionSummary>
              <Typography className={classes.heading}>تایید بورسیه </Typography>
              <Typography className={classes.secondaryHeading}>نظر نهایی مدیریت</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {scholarship.scholarshipRequestStatus === 100
                ? (
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={5}>
                      <Button
                        fullWidth
                        style={{ background: 'green' }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          setUserResponse({
                            isVote: false,
                            isOk: true,
                          })
                        }}
                      >
                        بورسیه تایید شود
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={2} />
                    <Grid item xs={12} md={5}>
                      <Button
                        fullWidth
                        style={{ background: 'red' }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          setUserResponse({
                            isVote: false,
                            isOk: false,
                          })
                        }}
                      >
                        بورسیه رد شود
                      </Button>
                    </Grid>
                  </Grid>
                )
                : (
                  <Typography>
                    {scholarship.scholarshipRequestStatus === 105 ? 'درخواست رد شده است!' : 'درخواست تایید شده است'}
                  </Typography>
                )}
            </AccordionDetails>
          </Accordion>
        )
        : null}
      <Dialog
        open={!!userResponse}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{userResponse?.isVote ? 'ثبت رای' : 'تایید بورسیه'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {userResponse?.isVote ? 'آیا رای ثبت شود' : 'آیا بورسیه تایید شود؟'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} color="primary">
            لغو
          </Button>
          <Button onClick={() => handleClose(true)} color="primary" autoFocus>
            بلی
          </Button>
        </DialogActions>
      </Dialog>

    </Paper>
  )
}

export default ScholarshipReview
